import Vue from "vue"
import Router from "vue-router"
import Home from "./views/Home.vue"
import Auth from "./views/Auth.vue"
import appConfig from "@/config"
import {logWebUserActivity, UserActivity} from "./data/repos/logWebUserActivity"

Vue.use(Router)

const routes: any[] = [
  {
    path: "/",
    name: "home",
    component: Home,
  },
  {
    path: "/dashboards/:id?",
    name: "dashboards",
    props: true,
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () => import(/* webpackChunkName: "dashboards" */ "./views/Dashboards.vue"),
    meta: {
      title: "Analytics dashboards",
    },
  },
  {
    path: "/auth",
    name: "auth",
    component: Auth,
  },
  {
    path: "/widget",
    name: "widget",
    component: () => import(/* webpackChunkName: "singleWidget" */ "./views/SingleWidget.vue"),
  },
  {
    path: "/about",
    name: "about",
    component: () => import(/* webpackChunkName: "about" */ "./views/About.vue"),
  },
]

export {routes}
const router = new Router({
  mode: "history",
  base: "/",
  routes,
})

router.beforeEach((to, from, next) => {
  const getWebUserActivity = () => {
    return {
      page: appConfig.BASE_URL + to.fullPath,
      referer: appConfig.BASE_URL + from.fullPath,
    } as UserActivity
  }
  if (!appConfig.BASE_URL) { // if configuration is not loaded postpone log submission
    setTimeout(() => logWebUserActivity(getWebUserActivity()), 5000)
  } else {
    logWebUserActivity(getWebUserActivity())
  }
  next()
})

export default router
